// export const API_URL = 'http://psp.com.ph/'
// export const WEB_URL = 'http://localhost'
export const WEB_URL = 'https://psp.com.ph';
